import { render } from "./Loader.vue?vue&type=template&id=14977b90"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"
script.render = render

export default script